import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell, X } from 'lucide-react';
import { api } from '@/services/api';
import { useApplicants } from '@/contexts/ApplicantContext';

interface Counts {
  [applicantId: string]: number;
}

export function InterviewBanner() {
  const { current } = useApplicants();
  const [counts, setCounts] = useState<Counts>({});
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    const tick = () =>
      api
        .get<Counts>('/notifications/unseen-counts')
        .then((c) => !cancelled && setCounts(c))
        .catch(() => {});
    tick();
    const handle = setInterval(tick, 30_000);
    return () => {
      cancelled = true;
      clearInterval(handle);
    };
  }, []);

  const n = counts[current] ?? 0;
  if (n <= 0) return null;

  return (
    <button
      onClick={() => navigate('/notifications')}
      className="flex w-full items-center justify-between gap-3 border-b border-red-200 bg-red-50 px-4 py-2 text-left text-sm transition hover:bg-red-100"
    >
      <span className="flex items-center gap-2 text-red-800">
        <Bell className="h-4 w-4" />
        <strong>{n}</strong> unread interview signal{n > 1 ? 's' : ''} — click to review
      </span>
      <X
        className="h-4 w-4 text-red-700"
        onClick={(e) => {
          e.stopPropagation();
          setCounts((c) => ({ ...c, [current]: 0 }));
        }}
      />
    </button>
  );
}
